const initialState = {
    reservationsResponseList: [],
    responseReservations: [],
    responseFilteredReservations: [],
    responseExportReservations: [],
    responseChangeEmailReservations: [],
    errorReservations: false,
    errorChangeEmailReservations: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "RESERVATIONS_RESPONSE_LIST":
            newState.reservationsResponseList = action.value;
            if (action.value.detail !== undefined) {
                newState.errorReservations = true;
            } else {
                newState.errorReservations = false;
            }
            //newState.responseReservation = []
            break;

        case "RESERVATIONS_RESPONSE_LIST_REDUCED":
            newState.reservationsResponseList = action.value;
            if (action.value.detail !== undefined) {
                newState.errorReservations = true;
            } else {
                newState.errorReservations = false;
            }
            //newState.responseReservation = []
            break;
        case "CHANGE_EMAIL_RESERVATIONS_RESPONSE":
            newState.responseChangeEmailReservations = action.value;
            if (action.value.status !== undefined) {
                newState.errorChangeEmailReservations = false;
            } else {
                newState.errorChangeEmailReservations = true;
            }
            break;
        case "RESERVATION_RESPONSE":
            newState.responseReservations = action.value;
            if (action.value.detail !== undefined) {
                newState.errorReservations = true;
            } else {
                newState.errorReservations = false;
            }
            break;
        case "FILTERED_RESERVATIONS_RESPONSE":
            newState.responseFilteredReservations = action.value;
            if (action.value.detail !== undefined || (action.value.status != undefined && action.value.status == 'Error')) {
                newState.errorReservations = true;
            } else {
                newState.errorReservations = false;
            }
            break;
        case "EXPORT_RESERVATIONS_RESPONSE":
            newState.responseExportReservations = action.url;
        default:
            return newState;
    }

    return newState;
};

export default reducer;